export default {
  data() {
    return {
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      },
      pageSizeOptions: [10, 20, 30, 50],
      totalRecords: null
    }
  }
}
